export const images = [
    { url: require('./img/gradation.png') },
    { url: require('./img/romance.png') },
    { url: require('./img/with_us_temp.png') },
    { url: require('./img/toberukara.png') },
    { url: require('./img/apac_raffle.png') },
    { url: require('./img/apac_poster1.png') },
    { url: require('./img/heartslabyul.png') },
];